module.exports = __webpack_public_path__ + "img/002-instagram.4ef1797e.svg";